import React from 'react';
import { s } from '../helpers';

export interface ToastNotificationProps {
  toast: string | null;
}

export const ToastNotification: React.FC<ToastNotificationProps> = ({ toast }) => {
  if (!toast) return null;

  return (
    <div
      style={s(
        `position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:10000;background:#01253C;color:#fff;font-size:13.5px;padding:12px 18px;border-radius:10px;box-shadow:0 12px 32px rgba(1,37,60,0.3);display:flex;align-items:center;gap:8px`
      )}
    >
      <i className="icon-circle-check" style={s(`color:#5FD3B8`)}></i>
      {toast}
    </div>
  );
};
